import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PreloadStatus from '../../Data/PreloadStatus';
import { getAppointmentsAction } from '../../Hooks/actionCreators';
import { getPostcodeComponent } from '../__helpers__/component.helpers';

const provider = 'amplifon'; // Will need to be dynamic when we use more than one provider

const FetchAppointments = ({
  configForFormId,
  components,
  isNextPageAppointmentBooking,
  appointments,
  preloadStatus,
  appointmentBookingPage,
}) => {
  const dispatch = useDispatch();
  const { localeCode, countryCode } = useSelector((store) => store.formConfig);

  useEffect(() => {
    if (!configForFormId) {
      return;
    }

    const postcodeComponent = getPostcodeComponent({ components });

    const shouldFetchAppointments =
      isNextPageAppointmentBooking &&
      !appointments &&
      postcodeComponent &&
      postcodeComponent?.input.value &&
      preloadStatus === PreloadStatus.COMPLETED;

    if (shouldFetchAppointments) {
      /**
       * AB shows after a page with Loader, if the postcode has been completed and conditional questions have been answered.
       * isNextPageAppointmentBooking will be true on the Loader page, after the postcode has been filled.
       * preloadStatus - may not be needed in the array here, but ensures that the iframe is ready to take appointments once they have been loaded
       */
      dispatch(
        getAppointmentsAction({
          postcode: postcodeComponent.input.value,
          country: countryCode,
          provider,
          appointmentBookingPage,
          locale: localeCode,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    configForFormId,
    isNextPageAppointmentBooking,
    appointments,
    preloadStatus,
    appointmentBookingPage,
    countryCode,
    localeCode,
  ]);

  return false; // This component does not render anything
};

export default FetchAppointments;
